module.exports = __webpack_public_path__ + "static/TT1383_TW-MARK-M01-clean-f4344d251405d143478a647ba2582987.png";